<div class="flex h-25 bg-gray-800 items-center justify-center">
  <div class="flex items-center justify-between w-4/5">
    <a routerLink="/" class="flex">
      <div class="flex gap-4 items-center">
        <b class="text-[#a3d55d] text-4xl leading-none">CMG</b>
        <span class="text-white text-lg">Servicing Docs - Bulk Export</span>
      </div>
    </a>
    <span class="text-white text-xl">
      {{ this.graphUserService.graphUser()?.displayName }}
    </span>
  </div>
</div>
